import type { Traducao } from '../tipos';

/** Textos de `aquisicao`. Preenchido pela tradução da área — ver ../README.md. */
export const aquisicao: Traducao = {
  pt: {
    cabecalho: {
      titulo: 'Aquisição de Campo',
      subtitulo: 'Capture fotos das máquinas mesmo sem conexão com a internet.',
      statusOnline: 'Online',
      statusOffline: 'Offline',
      online: 'ONLINE',
      offline: 'OFFLINE',
    },
    estado: {
      semProjeto: 'Selecione um projeto para realizar aquisição de campo.',
    },
    seletor: {
      rotulo: 'Máquina / Tarefa',
      placeholderBusca: 'Buscar ou digitar nome da máquina...',
      placeholderDigite: 'Digite o nome da máquina...',
      limparSelecao: 'Limpar seleção',
      badgePersonalizado: 'Nome personalizado',
      badgeCronograma: 'Máquina do cronograma',
      recentes: 'Recentes ({{quantidade}})',
      limparHistorico: 'Limpar histórico',
      sufixoPersonalizado: '(personalizado)',
      cronograma: 'Cronograma ({{quantidade}})',
      semResultados: 'Nenhuma máquina encontrada no cronograma.',
      usarPersonalizado: 'Usar nome personalizado:',
      semMaquinas: 'Nenhuma máquina carregada. Acesse o Cronograma online ao menos uma vez ou digite um nome personalizado.',
    },
    acao: {
      tirarFoto: 'Tirar Foto',
    },
    camera: {
      erroPermissao: 'Não foi possível acessar a câmera do dispositivo. Verifique as permissões.',
      capturarStreaming: 'Capturar via streaming',
      rapido: 'Rápido',
      rapidoBloqueado: 'Rápido (bloq.)',
      capturarNativa: 'Capturar usando a câmera nativa do celular',
      hdNativo: 'HD (Nativo)',
      qualidade: {
        titulo: 'Qualidade insuficiente no modo rápido.',
        detectada: 'Detectado {{largura}}x{{altura}}. Use o botão HD (Nativo).',
        semDeteccao: 'Resolução abaixo do mínimo. Use o botão HD (Nativo).',
      },
    },
    pendentes: {
      titulo: 'Fotos Pendentes ({{quantidade}})',
      baixarZipTitle: 'Baixar todas as fotos pendentes em um arquivo ZIP',
      baixarZip: 'Baixar ZIP',
      sincronizar: 'Sincronizar',
      enviando: 'Enviando...',
      vazio: 'Nenhuma foto pendente de sincronização para este projeto.',
      badgePersonalizado: 'Personalizado',
      contagemSingular: '{{quantidade}} foto pendente',
      contagemPlural: '{{quantidade}} fotos pendentes',
      maquinaAtual: 'Máquina atual selecionada',
      selecioneParaPreview: 'Selecione esta máquina no campo acima para liberar preview',
      ocultarPreview: 'Ocultar preview',
      mostrarPreview: 'Mostrar preview',
    },
    preview: {
      ultimas: 'Últimas {{limite}} fotos da máquina atual',
      carregando: 'Carregando preview...',
      vazio: 'Não há fotos pendentes para esta máquina.',
      altPendente: 'Pendente',
      excluirFoto: 'Excluir foto',
    },
    mensagem: {
      erroSalvar: 'Falha ao salvar a foto localmente.',
      confirmarExcluir: 'Tem certeza que deseja excluir esta foto não sincronizada?',
      erroDownload: 'Ocorreu um erro ao preparar o download das fotos.',
      semConexaoSync: 'Você precisa de conexão para sincronizar as fotos.',
      syncSucesso: '{{enviadas}} fotos enviadas com sucesso.',
      syncSucessoComFalhas: '{{enviadas}} fotos enviadas com sucesso. {{falharam}} falharam.',
      erroDesconhecido: 'Erro desconhecido.',
    },
  },
  en: {
    cabecalho: {
      titulo: 'Field Capture',
      subtitulo: 'Capture machine photos even without an internet connection.',
      statusOnline: 'Online',
      statusOffline: 'Offline',
      online: 'ONLINE',
      offline: 'OFFLINE',
    },
    estado: {
      semProjeto: 'Select a project to run field capture.',
    },
    seletor: {
      rotulo: 'Machine / Task',
      placeholderBusca: 'Search or type a machine name...',
      placeholderDigite: 'Type the machine name...',
      limparSelecao: 'Clear selection',
      badgePersonalizado: 'Custom name',
      badgeCronograma: 'Machine from the schedule',
      recentes: 'Recent ({{quantidade}})',
      limparHistorico: 'Clear history',
      sufixoPersonalizado: '(custom)',
      cronograma: 'Schedule ({{quantidade}})',
      semResultados: 'No machine found in the schedule.',
      usarPersonalizado: 'Use custom name:',
      semMaquinas: 'No machines loaded. Open the Schedule online at least once or type a custom name.',
    },
    acao: {
      tirarFoto: 'Take Photo',
    },
    camera: {
      erroPermissao: 'Could not access the device camera. Check the permissions.',
      capturarStreaming: 'Capture via streaming',
      rapido: 'Fast',
      rapidoBloqueado: 'Fast (blocked)',
      capturarNativa: 'Capture using the phone native camera',
      hdNativo: 'HD (Native)',
      qualidade: {
        titulo: 'Insufficient quality in fast mode.',
        detectada: 'Detected {{largura}}x{{altura}}. Use the HD (Native) button.',
        semDeteccao: 'Resolution below the minimum. Use the HD (Native) button.',
      },
    },
    pendentes: {
      titulo: 'Pending Photos ({{quantidade}})',
      baixarZipTitle: 'Download every pending photo in a ZIP file',
      baixarZip: 'Download ZIP',
      sincronizar: 'Sync',
      enviando: 'Uploading...',
      vazio: 'No photo pending sync for this project.',
      badgePersonalizado: 'Custom',
      contagemSingular: '{{quantidade}} pending photo',
      contagemPlural: '{{quantidade}} pending photos',
      maquinaAtual: 'Current machine selected',
      selecioneParaPreview: 'Select this machine in the field above to unlock the preview',
      ocultarPreview: 'Hide preview',
      mostrarPreview: 'Show preview',
    },
    preview: {
      ultimas: 'Last {{limite}} photos of the current machine',
      carregando: 'Loading preview...',
      vazio: 'There are no pending photos for this machine.',
      altPendente: 'Pending',
      excluirFoto: 'Delete photo',
    },
    mensagem: {
      erroSalvar: 'Failed to save the photo locally.',
      confirmarExcluir: 'Are you sure you want to delete this unsynced photo?',
      erroDownload: 'Something went wrong while preparing the photo download.',
      semConexaoSync: 'You need a connection to sync the photos.',
      syncSucesso: '{{enviadas}} photos uploaded successfully.',
      syncSucessoComFalhas: '{{enviadas}} photos uploaded successfully. {{falharam}} failed.',
      erroDesconhecido: 'Unknown error.',
    },
  },
};
